/** Generated from blog_post_metadata.csv — do not invent categories or pairings. */
export const BLOG_POST_METADATA = {
  "the-end-of-static-documents-how-intelligent-workflows-are-changing-enterprise-software": {
    category: "Document Intelligence",
    audience: "Business",
    sidebarProduct: "SafeVault",
    relatedSlugs: ["why-amitasoft-is-building-a-workflow-platform-around-documents", "why-financial-workflows-should-start-with-the-document"],
    status: "live",
  },
  "from-files-to-flow-amitasoft-is-redefining-work": {
    category: "Document Intelligence",
    audience: "Business",
    sidebarProduct: "SafeVault",
    relatedSlugs: ["the-end-of-static-documents-how-intelligent-workflows-are-changing-enterprise-software", "why-amitasoft-is-building-a-workflow-platform-around-documents"],
    status: "live",
  },
  "why-amitasoft-is-building-a-workflow-platform-around-documents": {
    category: "Document Intelligence",
    audience: "Business",
    sidebarProduct: "SafeVault",
    relatedSlugs: ["why-financial-workflows-should-start-with-the-document", "the-end-of-static-documents-how-intelligent-workflows-are-changing-enterprise-software"],
    status: "live",
  },
  "why-financial-workflows-should-start-with-the-document": {
    category: "Document Intelligence",
    audience: "Business",
    sidebarProduct: "SafeVault",
    relatedSlugs: ["why-amitasoft-is-building-a-workflow-platform-around-documents", "how-better-document-verification-can-speed-up-loan-approval"],
    status: "live",
  },
  "why-connected-data-ecosystems-are-the-future-of-business-operations": {
    category: "Operations",
    audience: "Business",
    sidebarProduct: "SafeVault",
    relatedSlugs: ["why-operational-clarity-must-come-from-system-design", "the-silent-killer-of-productivity-poor-process-handoffs"],
    status: "live",
  },
  "digital-transformation-trends-businesses-should-watch-in-2026": {
    category: "Digital Transformation",
    audience: "Business",
    sidebarProduct: "SafeVault",
    relatedSlugs: ["top-fintech-trends-reshaping-financial-services", "the-three-pillars-of-enterprise-digital-transformation"],
    status: "live",
  },
  "top-fintech-trends-reshaping-financial-services": {
    category: "Digital Transformation",
    audience: "Business",
    sidebarProduct: "CliQloan",
    relatedSlugs: ["digital-transformation-trends-businesses-should-watch-in-2026", "reimagining-fintech-platforms-with-intelligent-risk-detection"],
    status: "live",
  },
  "designing-secure-ai-systems-in-a-compliance-driven-world": {
    category: "Security & Compliance",
    audience: "Business",
    sidebarProduct: "SafeVault",
    relatedSlugs: ["when-audit-trails-are-optional-risk-is-guaranteed", "ai-cloud-security-the-trinity-shaping-digital-trust"],
    status: "live",
  },
  "you-have-every-tool-so-why-is-nothing-working": {
    category: "Operations",
    audience: "Business",
    sidebarProduct: "SafeVault",
    relatedSlugs: ["features-dont-fix-problemsworkflows-do", "the-problem-with-modern-work-isnt-speed-its-recovery-time"],
    status: "live",
  },
  "features-dont-fix-problemsworkflows-do": {
    category: "Operations",
    audience: "Business",
    sidebarProduct: "SafeVault",
    relatedSlugs: ["you-have-every-tool-so-why-is-nothing-working", "why-operational-clarity-must-come-from-system-design"],
    status: "live",
  },
  "the-silent-killer-of-productivity-poor-process-handoffs": {
    category: "Operations",
    audience: "Lending",
    sidebarProduct: "CliQloan",
    relatedSlugs: ["how-better-document-verification-can-speed-up-loan-approval", "why-connected-data-ecosystems-are-the-future-of-business-operations"],
    status: "live",
  },
  "the-problem-with-modern-work-isnt-speed-its-recovery-time": {
    category: "Operations",
    audience: "Business",
    sidebarProduct: "SafeVault",
    relatedSlugs: ["you-have-every-tool-so-why-is-nothing-working", "the-silent-killer-of-productivity-poor-process-handoffs"],
    status: "live",
  },
  "why-operational-clarity-must-come-from-system-design": {
    category: "Operations",
    audience: "Business",
    sidebarProduct: "SafeVault",
    relatedSlugs: ["why-connected-data-ecosystems-are-the-future-of-business-operations", "features-dont-fix-problemsworkflows-do"],
    status: "live",
  },
  "the-three-pillars-of-enterprise-digital-transformation": {
    category: "Digital Transformation",
    audience: "Business",
    sidebarProduct: "SafeVault",
    relatedSlugs: ["digital-transformation-trends-businesses-should-watch-in-2026", "why-connected-data-ecosystems-are-the-future-of-business-operations"],
    status: "live",
  },
  "when-audit-trails-are-optional-risk-is-guaranteed": {
    category: "Security & Compliance",
    audience: "Business",
    sidebarProduct: "SafeVault",
    relatedSlugs: ["designing-secure-ai-systems-in-a-compliance-driven-world", "ai-cloud-security-the-trinity-shaping-digital-trust"],
    status: "live",
  },
  "ai-cloud-security-the-trinity-shaping-digital-trust": {
    category: "Security & Compliance",
    audience: "Business",
    sidebarProduct: "SafeVault",
    relatedSlugs: ["designing-secure-ai-systems-in-a-compliance-driven-world", "when-audit-trails-are-optional-risk-is-guaranteed"],
    status: "live",
  },
  "how-ai-is-quietly-powering-the-worlds-most-reliable-digital-systems": {
    category: "AI & Automation",
    audience: "Business",
    sidebarProduct: "SafeVault",
    relatedSlugs: ["ai-cloud-security-the-trinity-shaping-digital-trust", "reimagining-fintech-platforms-with-intelligent-risk-detection"],
    status: "live",
  },
  "reimagining-fintech-platforms-with-intelligent-risk-detection": {
    category: "AI & Automation",
    audience: "Lending",
    sidebarProduct: "CliQloan",
    relatedSlugs: ["how-better-document-verification-can-speed-up-loan-approval", "top-fintech-trends-reshaping-financial-services"],
    status: "live",
  },
  "from-document-chaos-to-decision-ready-workflows-how-amitasoft-connects-safevault-and-cliqloan": {
    category: "Document Intelligence",
    audience: "Business",
    sidebarProduct: "SafeVault",
    relatedSlugs: ["why-financial-workflows-should-start-with-the-document", "how-better-document-verification-can-speed-up-loan-approval"],
    status: "live",
  },
  "how-better-document-verification-can-speed-up-loan-approval": {
    category: "Lending",
    audience: "Lending",
    sidebarProduct: "CliQloan",
    relatedSlugs: ["the-silent-killer-of-productivity-poor-process-handoffs", "reimagining-fintech-platforms-with-intelligent-risk-detection"],
    status: "live",
  },
  "how-to-reduce-tax-season-follow-ups": {
    category: "Tax",
    audience: "CPA firms",
    sidebarProduct: "TaxFlo",
    relatedSlugs: ["how-better-document-verification-can-speed-up-loan-approval", "why-financial-workflows-should-start-with-the-document"],
    status: "pending publish",
  },
  "cpa-firm-capacity-tax-season": {
    category: "Tax",
    audience: "CPA firms",
    sidebarProduct: "TaxFlo",
    relatedSlugs: ["how-to-reduce-tax-season-follow-ups", "tax-season-client-communication"],
    status: "live",
  },
  "tax-season-client-communication": {
    category: "Tax",
    audience: "CPA firms",
    sidebarProduct: "TaxFlo",
    relatedSlugs: ["how-to-reduce-tax-season-follow-ups", "cpa-firm-capacity-tax-season"],
    status: "live",
  },
  "how-long-to-keep-tax-records": {
    category: "Tax",
    audience: "Consumers",
    sidebarProduct: "SafeVault",
    relatedSlugs: ["how-to-organize-tax-documents", "how-to-reduce-tax-season-follow-ups"],
    status: "live",
  },
  "blog-v2-template-verification": {
    category: "Document Intelligence",
    audience: "Business",
    sidebarProduct: "SafeVault",
    relatedSlugs: ["why-financial-workflows-should-start-with-the-document", "how-to-reduce-tax-season-follow-ups"],
    status: "live",
  },
  "how-to-organize-tax-documents": {
    category: "Tax",
    audience: "Consumers",
    sidebarProduct: "SafeVault",
    relatedSlugs: ["how-long-to-keep-tax-records", "how-to-reduce-tax-season-follow-ups"],
    status: "live",
  },
};

export function getPostMetadata(slug) {
  const row = BLOG_POST_METADATA[slug];
  if (!row) {
    throw new Error(`Blog v2 metadata missing for slug: ${slug}`);
  }
  return row;
}

